require('./style.css');
var tmpl = require('./main.ejs');
var tmplItem = require('./item.ejs');

var ScrollView = function () {
  this.ids = {};
  this.datas = [];
  this.sends = [];
  this.isHide = false;
  this.top = 0;
  this.items = [];
  this.itemHeight = 0;
  this.space = 10;
  this.isPause = false;
  this.time = -1;
  this.init();
};

ScrollView.prototype.init = function () {
  this.initDom();
  this.initEvent();
};


ScrollView.prototype.initDom = function () {
  var div = document.createElement('div');
  div.innerHTML = tmpl();
  this.el = div.children[0];
  this.elBox = this.el.querySelector('.c-scrollview__scrolls');
};

ScrollView.prototype.initEvent = function () {

};

ScrollView.prototype.frameRun = function () {
  requestAnimationFrame(function () {
    this.frameRun();

    if (this.isPause) {
      return;
    }

    var top, height;
    var index = 0;
    if (this.top < 0 && this.items.length > 0) {
      top = this.top;
      while (top < 0 && this.items[index]) {
        height = this.items[index].height;
        if (height < Math.abs(top)) {
          this.items[index].elm.css('opacity', 0);
        } else {
          this.items[index].elm.css('opacity', (height + top)/height);
        }
        top = top + height;
        index++;
      }
    }

    if (this.boxHeight < this.top +  this.itemHeight) {
      if (this.top +  this.itemHeight - this.boxHeight > this.space) {
        this.top = this.top - this.space;
      } else {
        this.top = this.top - (this.top +  this.itemHeight - this.boxHeight);
      }
      $(this.elBox).css({
        'transform': 'translate3d(0,' + this.top + 'px,0)',
        'webkitTransform': 'translate3d(0,' + this.top + 'px,0)'
      });
    }
  }.bind(this));
};

ScrollView.prototype.fliterDatasBySend = function (datas) {
  var result = [];
  var item;
  for (var i = 0, iLen = datas.length; i < iLen; i++) {
    item = datas[i];
    var isSelect = false;
    for (var j = 0, jLen = this.sends.length; j < jLen; j++) {
      if (this.sends[j].content == item.content) {
        this.sends.splice(j, 1);
        isSelect = true;
        break;
      }
    }
    if (!isSelect) {
      result.push(item);
    }
  }
  return result;
};

ScrollView.prototype.fliterDatas = function (datas) {
  datas = this.fliterDatasBySend(datas);
  var result = [];
  var item;
  var now = new Date().valueOf();
  for (var i = 0, iLen = datas.length; i < datas.length; i++) {
    item = datas[i];
    if (typeof item.id == 'undefined') {
      result.push(item);
    } else {
      if (typeof item.id == 'string' && item.id.indexOf('sendBack_') >=0) {
        this.sends.push(item);
      }
      if (!this.ids[item.id]) {
        this.ids[item.id] = now;
        result.push(item);
      } else if (now - this.ids[item.id] > 1 * 60 * 1000 && item.__type == 'online') {
        this.ids[item.id] = now;
        result.push(item);
      }
    }
  }
  return result;
};

ScrollView.prototype.add = function (datas) {
  datas = this.fliterDatas(datas);
  this.datas = this.datas.concat(datas);
};

ScrollView.prototype.addItem = function () {

  requestAnimationFrame(function () {
    this.addItem();

    this.time = this.time + 1;

    if (this.time % 60 != 0) {
      return;
    }

    if (this.isPause) {
      return;
    }

    if (this.datas.length >= 1) {
        this.removeItem();
        var item = this.datas.shift();
        var $item = $(tmplItem({item: item}));
        $(this.elBox).append($item);
        var height = $item[0].offsetHeight;
        this.space = height / 30;
        this.items.push({
          elm: $item,
          height: height,
          id: item.id
        });
        this.itemHeight = this.itemHeight + height;
    }

  }.bind(this));

};

ScrollView.prototype.removeItem = function () {
  var item;
  if (this.items.length > 0 && this.top + this.items[0].height < 0) {
    while (this.top + this.items[0].height < 0) {
      item = this.items.shift();
      this.ids[item.id] = false;
      item.elm.remove();
      this.top = this.top + item.height;
      this.itemHeight = this.itemHeight - item.height;
    }
    $(this.elBox).css('transform', 'translate3d(0,' + this.top + 'px,0)');
  }
};

ScrollView.prototype.removeData = function (remain) {
  if (this.datas.length <= remain) {
    return;
  }
  this.datas = this.datas.slice(this.datas.length - remain);
};

ScrollView.prototype.renderTo = function (parentNode) {
  parentNode.appendChild(this.el);
  var height = $(parentNode).height();
  $(this.el).height(height);
  this.boxHeight = height;
  this.top = this.top + height;
  $(this.elBox).css('transform', 'translate3d(0,' + this.top + 'px,0)');
  this.addItem();
  this.frameRun();
};

ScrollView.prototype.destory = function () {
  this.el.parentNode.removeChild(this.el);
};

ScrollView.prototype.reset = function () {
  this.top = this.boxHeight;
  this.space = 10;
  this.items = [];
  this.itemHeight = 0;
  $(this.elBox).empty();
  $(this.elBox).css('transform', 'translate3d(0,' + this.top + 'px,0)');
};

ScrollView.prototype.pause = function () {
  this.isPause = true;
};

ScrollView.prototype.play = function () {
  this.isPause = false;
};

ScrollView.prototype.hide = function () {
  this.el.style.visibility = 'hidden';
};

ScrollView.prototype.show = function () {
  this.el.style.visibility = 'visible';
};


module.exports = ScrollView;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.barrage.mobile/app/modules/scrollview/index.js